/**
 * Success/error haptics via the Vibration API where the device supports it
 * (Android Chrome). iOS ignores navigator.vibrate ??? the guard keeps it safe.
 */
export type HapticKind = 'light' | 'select' | 'success' | 'error';

const PATTERNS: Record<HapticKind, number | number[]> = {
  light: 8,
  select: 5,
  success: [12, 40, 18],
  error: [25, 45, 25],
};

export function haptic(kind: HapticKind = 'light'): void {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  try {
    navigator.vibrate(PATTERNS[kind]);
  } catch {
    /* some browsers throw when vibration is blocked ??? never fatal */
  }
}
